import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatasheetBuilderService {

  datasheetBuilderSubject: BehaviorSubject<void> = new BehaviorSubject<void>(null)

  constructor() { }
}
